import React from 'react';
import cn from 'classnames';

import { useIsPrimaryDark } from 'widget/hooks';

interface Button {
  children: React.ReactNode;
  isDisabled?: boolean;
  isSubmitting?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit';
}

const Button = ({
  children,
  isDisabled,
  isSubmitting,
  onClick,
  type = 'button',
}: Button) => {
  const isPrimaryDark = useIsPrimaryDark();

  return (
    <button
      className={cn('whatcrm-widget-btn', {
        'whatcrm-widget-btn_dark': isPrimaryDark,
      })}
      disabled={isDisabled || isSubmitting}
      onClick={() => onClick?.()}
      type={type}
    >
      {children}
    </button>
  );
};

export default Button;
